const configuration = {
	defaults: {
		maxFileSize: 1000,
		minFiles: 1,
		maxFiles: 2,
		allowMultiple: false,
		limitUploads: false,
		limitFileFormat: false,
		includeDescription: false,
		fileFormats: '',
		required: true,
	},
};

export default configuration;
